<div class="row wrapper border-bottom white-bg page-heading" *ngIf="!embedded">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a [routerLink]="['/fire-foresight/admin']">Fire Foresight Admin</a>
      </li>
      <li class="breadcrumb-item">
        <a>Sites</a>
      </li>
    </ol>
  </div>
</div>

<!-- Add Site Modal -->
<div class="modal fade" bsModal #addSiteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD SITE</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addSiteModal.hide()"></button>
      </div>
      <div class="modal-body">
        <h6 class="text-muted">Required</h6>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Name <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="newSite.name" (blur)="markNewFieldTouched('name')"
                       class="form-control" [class.is-valid]="newTouched.name && newSite.name"
                       [class.is-invalid]="newTouched.name && !newSite.name" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Site Uri <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="newSite.siteUri" (blur)="markNewFieldTouched('siteUri')"
                       class="form-control" [class.is-valid]="newTouched.siteUri && newSite.siteUri"
                       [class.is-invalid]="newTouched.siteUri && !newSite.siteUri" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Altitude <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="newSite.cameraAltitude" (blur)="markNewFieldTouched('cameraAltitude')"
                       class="form-control" [class.is-valid]="newTouched.cameraAltitude && newSite.cameraAltitude >= 0"
                       [class.is-invalid]="newTouched.cameraAltitude && !(newSite.cameraAltitude >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Elevation <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [(ngModel)]="newSite.cameraElevation" (blur)="markNewFieldTouched('cameraElevation')"
                       class="form-control" [class.is-valid]="newTouched.cameraElevation && newSite.cameraElevation != null"
                       [class.is-invalid]="newTouched.cameraElevation && newSite.cameraElevation == null" required>
                  <option [ngValue]="null">-- Select Camera Elevation --</option>
                  <option *ngFor="let option of cameraElevationOptions" [ngValue]="option.value">{{option.label}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Height <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="newSite.cameraHeight" (blur)="markNewFieldTouched('cameraHeight')"
                       class="form-control" [class.is-valid]="newTouched.cameraHeight && newSite.cameraHeight >= 0"
                       [class.is-invalid]="newTouched.cameraHeight && !(newSite.cameraHeight >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Field Of View <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [(ngModel)]="newSite.fieldOfView" (blur)="markNewFieldTouched('fieldOfView')"
                       class="form-control" [class.is-valid]="newTouched.fieldOfView && newSite.fieldOfView != null"
                       [class.is-invalid]="newTouched.fieldOfView && newSite.fieldOfView == null" required>
                  <option [ngValue]="null">-- Select Field Of View --</option>
                  <option *ngFor="let option of fieldOfViewOptions" [ngValue]="option.value">{{option.label}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Image Width <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="newSite.imageWidth" (blur)="markNewFieldTouched('imageWidth')"
                       class="form-control" [class.is-valid]="newTouched.imageWidth && newSite.imageWidth >= 0"
                       [class.is-invalid]="newTouched.imageWidth && !(newSite.imageWidth >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Image Height <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="newSite.imageHeight" (blur)="markNewFieldTouched('imageHeight')"
                       class="form-control" [class.is-valid]="newTouched.imageHeight && newSite.imageHeight >= 0"
                       [class.is-invalid]="newTouched.imageHeight && !(newSite.imageHeight >= 0)" required/>
              </div>
            </div>
          </div>
        </div>

        <h6 class="text-muted mt-3">Optional</h6>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Customer</label>
              <div class="input-group m-b">
                <select [(ngModel)]="newSite.customerId" class="form-control">
                  <option [ngValue]="null">-- None --</option>
                  <option *ngFor="let customer of app.customers" [ngValue]="customer.customerId">{{customer.customerName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Next Scheduled Patrol</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="newSite.nextScheduledPatrol" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Latitude</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="newSite.latitude" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Longitude</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="newSite.longitude" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Pitch Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="newSite.pitchError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Roll Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="newSite.rollError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Yaw Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="newSite.yawError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Dem Url</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="newSite.demUrl" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Storage Base Url</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="newSite.storageBaseUrl" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addSiteModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveNewSite();addSiteModal.hide()"
                class="btn btn-white"
                [disabled]="!isNewSiteValid()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Site Modal -->
<div class="modal fade" bsModal #editSiteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">EDIT SITE</h5> <span class="pt-2">{{editSite.siteId}}</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editSiteModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Site Id <small class="text-muted">(read-only)</small></label>
              <div class="input-group m-b">
                <input type="text" [value]="editSite.siteId" class="form-control text-muted" readonly tabindex="-1"/>
              </div>
            </div>
          </div>
        </div>

        <h6 class="text-muted">Required</h6>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Name <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="editSite.name" (blur)="markEditFieldTouched('name')"
                       class="form-control" [class.is-valid]="editTouched.name && editSite.name"
                       [class.is-invalid]="editTouched.name && !editSite.name" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Site Uri <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="editSite.siteUri" (blur)="markEditFieldTouched('siteUri')"
                       class="form-control" [class.is-valid]="editTouched.siteUri && editSite.siteUri"
                       [class.is-invalid]="editTouched.siteUri && !editSite.siteUri" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Altitude <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="editSite.cameraAltitude" (blur)="markEditFieldTouched('cameraAltitude')"
                       class="form-control" [class.is-valid]="editTouched.cameraAltitude && editSite.cameraAltitude >= 0"
                       [class.is-invalid]="editTouched.cameraAltitude && !(editSite.cameraAltitude >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Elevation <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [(ngModel)]="editSite.cameraElevation" (blur)="markEditFieldTouched('cameraElevation')"
                       class="form-control" [class.is-valid]="editTouched.cameraElevation && editSite.cameraElevation != null"
                       [class.is-invalid]="editTouched.cameraElevation && editSite.cameraElevation == null" required>
                  <option [ngValue]="null">-- Select Camera Elevation --</option>
                  <option *ngFor="let option of cameraElevationOptions" [ngValue]="option.value">{{option.label}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Camera Height <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="editSite.cameraHeight" (blur)="markEditFieldTouched('cameraHeight')"
                       class="form-control" [class.is-valid]="editTouched.cameraHeight && editSite.cameraHeight >= 0"
                       [class.is-invalid]="editTouched.cameraHeight && !(editSite.cameraHeight >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Field Of View <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <select [(ngModel)]="editSite.fieldOfView" (blur)="markEditFieldTouched('fieldOfView')"
                       class="form-control" [class.is-valid]="editTouched.fieldOfView && editSite.fieldOfView != null"
                       [class.is-invalid]="editTouched.fieldOfView && editSite.fieldOfView == null" required>
                  <option [ngValue]="null">-- Select Field Of View --</option>
                  <option *ngFor="let option of fieldOfViewOptions" [ngValue]="option.value">{{option.label}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Image Width <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="editSite.imageWidth" (blur)="markEditFieldTouched('imageWidth')"
                       class="form-control" [class.is-valid]="editTouched.imageWidth && editSite.imageWidth >= 0"
                       [class.is-invalid]="editTouched.imageWidth && !(editSite.imageWidth >= 0)" required/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Image Height <span class="text-danger">*</span></label>
              <div class="input-group m-b">
                <input type="number" min="0" [(ngModel)]="editSite.imageHeight" (blur)="markEditFieldTouched('imageHeight')"
                       class="form-control" [class.is-valid]="editTouched.imageHeight && editSite.imageHeight >= 0"
                       [class.is-invalid]="editTouched.imageHeight && !(editSite.imageHeight >= 0)" required/>
              </div>
            </div>
          </div>
        </div>

        <h6 class="text-muted mt-3">Optional</h6>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Customer</label>
              <div class="input-group m-b">
                <select [(ngModel)]="editSite.customerId" class="form-control">
                  <option [ngValue]="null">-- None --</option>
                  <option *ngFor="let customer of app.customers" [ngValue]="customer.customerId">{{customer.customerName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Next Scheduled Patrol</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="editSite.nextScheduledPatrol" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Latitude</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="editSite.latitude" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Longitude</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="editSite.longitude" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Pitch Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="editSite.pitchError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Roll Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="editSite.rollError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Yaw Error</label>
              <div class="input-group m-b">
                <input type="number" [(ngModel)]="editSite.yawError" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Dem Url</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="editSite.demUrl" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Storage Base Url</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="editSite.storageBaseUrl" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="editSiteModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="saveEditSite();editSiteModal.hide()"
                class="btn btn-white"
                [disabled]="!isEditSiteValid()">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight" id="sites">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-2 bg-emphasis bg-opacity-25">
        <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <span class="flex-grow-1">Sites</span>
          <button (click)="openAddModal();addSiteModal.show()" class="btn btn-outline-default">Add Site</button>
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col">Site Uri</th>
                <th scope="col">Customer</th>
                <th scope="col">Latitude</th>
                <th scope="col">Longitude</th>
                <th scope="col">Patrol Segments</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of sites">
                <td>{{item.siteId}}</td>
                <td>{{item.name}}</td>
                <td>{{item.siteUri}}</td>
                <td>{{getCustomerName(item.customerId)}}</td>
                <td>{{item.latitude}}</td>
                <td>{{item.longitude}}</td>
                <td>{{item.patrolSegments?.length || 0}}</td>
                <td>
                  <a (click)="openEditModal(item, editSiteModal)" class="btn btn-outline-default"><i class="fa fa-pencil"></i></a>
                </td>
              </tr>
              <tr *ngIf="!loading && sites.length === 0">
                <td colspan="8" class="text-center text-muted">No sites found.</td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex align-items-center justify-content-between">
            <span>Page {{page}} of {{totalPages}} ({{totalCount}} total)</span>
            <div>
              <button class="btn btn-outline-default" [disabled]="page <= 1" (click)="previousPage()">Previous</button>
              <button class="btn btn-outline-default ms-2" [disabled]="page >= totalPages" (click)="nextPage()">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
